export const OWNER_EMAIL = 'tatiana@penzo.no';
export const EMAIL_SUBJECT = 'Penzo.no';
